// (function () {
// 	'use strict';

//     const module = angular.module('imApp');

//     module.component('deliveryMethod', {
//         templateUrl: 'views/components/views/deliveryMethod/deliveryMethod.template.html?v=' + module.version,
//         controllerAs: 'vm',
// 		controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'deliveryMethodService', 'pickJobGrpsService', 'economyService', 'translateService', function ($stateParams, stateService, utilityService, modalService, deliveryMethodService, pickJobGrpsService, economyService, translateService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let deliveryMethodNo = $stateParams.deliverymethod_no;
			
//             let translations = {
//                 confirm_title: '',
//                 confirm_message: '',
//                 confirm_ok_label: '',
//                 confirm_cancel_label: '',
//                 error: '',
//                 ok: ''
//             };

// 			vm.model = {
//                 deliveryMethodNameButtons: [
//                     { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('deliverymethodlangs', { deliverymethod_no: vm.model.edit.deliverymethod_no }) }
//                 ],
//                 pickJobGroupButtons: [
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('stockplaces') }
//                 ],
//                 pickJobGroupButtons2: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.pickjobgrp_keyno = '0' },
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('stockplaces') }
//                 ],
//                 transCarrierServicesButtons: [
//                     {
//                         id: 'goto',
//                         icon: 'fa fa-chevron-right',
//                         color: 'primary',
//                         type: 'primary',
//                         onClick: () => {
//                             deliveryMethodService.saveObj(vm.model.edit).then(function (response) {
//                                 if (response[0].iserror !== '1') {
//                                     modalService.show({
//                                         type: 'warning',
//                                         title: translations.error,
//                                         message: response[0].message,
//                                         buttons: [{
//                                             label: translations.ok,
//                                             cssClass: 'btn-warning',
//                                             action: function (dialogItself) {
//                                                 dialogItself.close();
//                                             }
//                                         }]
//                                     });
//                                 } else {
//                                     stateService.go('deliverymethodservices', { deliverymethod_no: vm.model.edit.deliverymethod_no });
//                                 }
//                             });
//                         }
//                     }
//                 ],
// 				edit: {},
// 				selectListTransCarriers: [],
// 				selectListTransCarrierProducts: [],
// 				selectListPickJobGroups: [],
// 				selectListReturnMethods: [],
//                 selectListBusinessSites: [],
//                 lockedSave: false,
//                 lockedDelete: false
// 			};

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATE SERVICE

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATE SERVICE

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await deliveryMethodService.getEdit({ deliverymethod_no: deliveryMethodNo }))[0];
// 			}
			
//             async function loadPickJobGroups() {
//                 vm.model.selectListPickJobGroups = await pickJobGrpsService.listPickJobGroups({ stockplace_id: 'ALL' });
//             }

//             async function loadBusinessSites() {
//                 vm.model.selectListBusinessSites = await economyService.listBusinessSites({ add_all: '1' });
//             }

//             async function loadReturnMethods() {
//                 vm.model.selectListReturnMethods = await deliveryMethodService.listReturnMethods();
// 			}

//             async function loadTransCarriers() {
//                 vm.model.selectListTransCarriers = await deliveryMethodService.listTransCarriers();
// 			}

//             async function loadTransCarrierProducts() {
//                 if (utilityService.validateParmsValue(vm.model.edit.transcarrier_keyno) !== true) return;

//                 return vm.model.selectListTransCarrierProducts = await deliveryMethodService.listTransCarrierProducts({ transcarrier_keyno: vm.model.edit.transcarrier_keyno });
// 			}

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

// 			// uased by HTML
// 			vm.validateNumber = function (num) {
// 				var out = 0;
// 				try {
// 					out = parseInt(num);
// 				} catch (e) { }
// 				return out;
// 			};

//             // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//             vm.deleteValues = function () {
//                 vm.model.lockedDelete = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     deliveryMethodService.deleteItem({ deliverymethod_no: vm.model.edit.deliverymethod_no }).then(function () {
//                         vm.model.lockedDelete = false;
//                         stateService.go('deliverymethods');
//                     }, function () {
//                         vm.model.lockedDelete = false;
//                     });
//                 }, function () {
//                     vm.model.lockedDelete = false;
//                 });
//             }

//             // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 deliveryMethodService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].iserror !== '1') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                             message: response[0].message,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                         stateService.go('deliverymethods');
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'transcarrier_keyno':
//                         if (utilityService.validateWatchValue(value, vm.model.edit.transcarrier_keyno) !== true) return;

//                         vm.model.edit.transcarrier_keyno = value;

//                         if (utilityService.validateParmsValue(vm.model.edit.transcarrier_keyno) !== true) return;

//                         loadTransCarrierProducts();
//                         vm.model.edit.transcarrier_services = '';
//                         break;
//                     case 'transcarrier_product_keyno':
//                         if (utilityService.validateWatchValue(value, vm.model.edit.transcarrier_product_keyno) !== true) return;

//                         vm.model.edit.transcarrier_product_keyno = value;

//                         if (utilityService.validateParmsValue(vm.model.edit.transcarrier_product_keyno) !== true) return;

//                         vm.model.edit.transcarrier_services = '';
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadTransCarriers();
//                 loadPickJobGroups();
//                 loadReturnMethods();
//                 loadBusinessSites();
//                 loadTransCarrierProducts();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
